export default {
  install(Vue) {
    Vue.prototype.$title = function(titleKey) {
      const appName = this.$root.titleName;
      return  `${titleKey} | ${appName}`;
    }
  }
}